/** 店鋪單據收件箱（Overseas patch 432） */
export const STORE_RECEIPT_INBOX_MENU_IDS = {
  desk: 991150,
  view: 991151,
  gate: 991152
}

export default STORE_RECEIPT_INBOX_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/storeReceiptInbox.js